import { useCallback } from 'react';

import { useModal } from '@kc-console/context';

import { AddFavoriteModal, type AddFavoriteModalProps } from '../modals';
import { useRefinedFavoriteServiceState } from './useRefinedFavoriteServiceState';

interface OpenFavoriteServiceModalOptions {
  initialSelected?: string[];
  onEditSuccess?: () => void;
}

export const useOpenFavoriteServiceModal = () => {
  const { openModal } = useModal();
  const { favoriteServices = [] } = useRefinedFavoriteServiceState();

  return useCallback(
    (options?: OpenFavoriteServiceModalOptions) => {
      const initialSelected =
        options?.initialSelected ?? favoriteServices.map(service => service.name);

      openModal<AddFavoriteModalProps>({
        Component: AddFavoriteModal,
        props: {
          initialSelected,
          onSubmit: options?.onEditSuccess,
        },
      });
    },
    [favoriteServices, openModal],
  );
};
